import { useState, useEffect } from "react";
import { getIndentInvoiceNoList, getIndentNoListByInvoiceNo } from "../services/productionService";

const useIndentNoListByInvoiceNo = () => {
    const [filteredIndentNoList, setFilteredIndentNoList] = useState([]);
    const [isIndentNoListLoaded, setIsIndentNoListLoaded] = useState(false);
    const [selectedIndentNo, setSelectedIndentNo] = useState(null);
    const [selectedIndentNoID, setSelectedIndentNoID] = useState(null);

    const fetchIndentNoList = async (selectedInvoiceNumber = null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_invoice_no: selectedInvoiceNumber
        };

        try {
            const data = await getIndentNoListByInvoiceNo(para);
            if (data && data.length > 0) {
                setFilteredIndentNoList(data);
                setIsIndentNoListLoaded(true);
            }
            else {
                setFilteredIndentNoList([]);
                setIsIndentNoListLoaded(false);
            }
        } catch (error) {
            throw new Error(`Error fetching invoice numbers: ${error.message}`);
        }
    };

    useEffect(() => {
        if (!isIndentNoListLoaded) {
            fetchIndentNoList();
        }
    }, [isIndentNoListLoaded]);

    const loadIndentNoByID = async (selectedInvoiceNumber) => {
        await fetchIndentNoList(selectedInvoiceNumber);
    };

    return {
        filteredIndentNoList,
        setFilteredIndentNoList,
        loadIndentNoByID,
        selectedIndentNo,
        setSelectedIndentNo,
        selectedIndentNoID,
        setSelectedIndentNoID
    };
};

export default useIndentNoListByInvoiceNo;
